import * as yup from 'yup'

import { stringShema } from '@/validation'

export const validationSchema = yup.object().shape({
  customerName: stringShema,
  customerPhone: yup.string().required('Обязательное поле').min(15, 'Не верный формат телефона'),
  customerEmail: yup.string().email('Не верный формат email'),
})
